<template>
  <div class="h-100 d-flex flex-column">
    <div class="sidebar-top p-3">


      <prompt></prompt>
    </div>
    <div class="sidebar-bot btn-box">
      <img :src="this.resultPage.outputImage" class="w-100 mask-image">

    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import Prompt from "../../components/Elements/Prompt.vue";

export default {
  name: 'SidebarLeftInpaint',
  props: {},
  components: {
    Prompt
  },
  mixins: [store],
  data() {
    return {};
  },
  mounted: function () {},
  created: function () {},
  methods: {},
  computed: {},
};
</script>
<style lang="scss" scoped>
.sidebar-item {
  padding: 20px 20px;
  border-bottom: 1px solid #CBCBCB;
  width: 100%;
  background: white;
  color: black;
}

.btn-box {
  min-height: 105px;
  height: 105px;
}
.gap-10 {
  gap: 10px;
}
</style>
